import { parseHref } from '@tanstack/history';
import {
	createBrowserHistory,
	createLazyRoute,
	createLink,
	createMemoryHistory,
	createRootRoute,
	createRoute,
	createRouter,
	Outlet,
	redirect,
	RouterProvider,
	useBlocker,
	useCanGoBack,
	useLoaderData,
	useLocation,
	useMatches,
	useRouter,
	useRouterState,
} from '@tanstack/react-router';
import { lock } from './lock-unlock';

/**
 * Private APIs for the boot package only.
 * These are router setup and internal utilities that should not be used
 * by individual routes.
 */
export const privateApis = {};

// Lock the private APIs so only authorized modules can access them
lock( privateApis, {
	// Router creation and setup
	createBrowserHistory,
	createLazyRoute,
	createMemoryHistory,
	createRouter,
	createRootRoute,
	createRoute,
	Outlet,
	RouterProvider,

	// Internal routing utilities
	redirect,
	createLink,
	useCanGoBack,
	useLoaderData,
	useLocation,
	useMatches,
	useRouter,
	useRouterState,
	useBlocker,

	// History utilities
	parseHref,
} );
